/**
 * Returns middleware URL
 * @returns {string}
 */
export function getMiddlewareUrl() {
  // @ts-ignore
  const env = import.meta.env
  const VITE_MIDDLEWARE_URL = env.VITE_MIDDLEWARE_URL

  const prod = 'https://trbotrkr.com'

  if (VITE_MIDDLEWARE_URL === 'undefined') {
    return prod
  }

  const url = VITE_MIDDLEWARE_URL || prod

  return url
}
